import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../assets/css/common.css';
import Header from './Header';
import Sidebar from './Sidebar';

const calibrationItems = [
  { to: '/calibration/queue', label: '보정 대기열' },
];

const CalibrationLayout = () => (
  <div className="wrap">
    <Header />
    <div className="section_area">
      <Sidebar items={calibrationItems} />
      <div className="section_wrap">
        <Outlet />
      </div>
    </div>
  </div>
);

export default CalibrationLayout;
